import i18n from '@/i18n/i18n';

export default [
    {
        path: '/hsbc/bank-accounts',
        name: 'hsbc-bank-accounts',
        component: () => import('@/views/app/hsbc/pages/bank-accounts/Index.vue'),
        meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU HSBC REPORT'],
            breadcrumb: [
                { title: 'Home', url: '/' },
                { title: i18n.messages[i18n.locale].bank_accounts, url: '/hsbc/bank-accounts', active: true },
            ]
        }
    },
    {
        path: '/hsbc/bank-account/:account/reports',
        name: 'hsbc-bank-account-reports',
        component: () => import('@/views/app/hsbc/pages/bank-account-reports/Index.vue'),
        meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU HSBC REPORT'],
            breadcrumb: [
                { title: 'Home', url: '/' },
                { title: i18n.messages[i18n.locale].bank_accounts, url: '/hsbc/bank-accounts' },
                { title: i18n.messages[i18n.locale].reports, url: '/hsbc/bank-account-reports', active: true },
            ]
        }
    },
     {
        path: '/hsbc/bank-account/report/:report/transactions',
        name: 'hsbc-bank-account-report-transactions',
        component: () => import('@/views/app/hsbc/pages/bank-account-transactions/Index.vue'),
        meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU HSBC REPORT'],
            breadcrumb: [
                { title: 'Home', url: '/' },
                { title: i18n.messages[i18n.locale].bank_accounts, url: '/hsbc/bank-accounts' },
                { title: i18n.messages[i18n.locale].transactions, url: '/hsbc/bank-account-transactions', active: true },
            ]
        }
    }
]
